/*
 * Merci de mettre impérativement en place
 * un linter dans votre IDE.
 *
 * on peut rajouter un slider
 * documentation : http://ganlanyuan.github.io/tiny-slider/
 * ajouter cette ligne (et rajouter le css) :
 * import 'tiny-slider';
 */

import 'clic-clac';
import imageRatios from 'image-ratios';
import svg4everybody from 'svg4everybody';
import 'fg-loadcss/src/cssrelpreload';
import Sticky from 'sticky-js';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.min.js';
import './cookies';

let isSticky = false;
let sticky;


var myLazyLoad = new LazyLoad({
  elements_selector: "[data-lazy-image]"
});

const startSticky = () => {
  if (window.matchMedia('(min-width: 1901px)').matches && !isSticky) {
    isSticky = true;
    sticky = new Sticky('.sticky-menu__container', {
      'data-sticky-class': 'sticky-menu__container--stuck'
    });
  }

  if (isSticky && !window.matchMedia('(min-width: 1671px)').matches) {
    isSticky = false;
    sticky.destroy();
  }
};

window.addEventListener('resize', startSticky);
startSticky();

// import './cookies';
// import './same-size';

imageRatios({
  imagesSelector: '[data-image-ratios]',
  ratios: [
    { name: '1-1', value: 1 },
    { name: '16-9', value: 16 / 9 },
    { name: '4-3', value: 4 / 3 },
    { name: '7-2', value: 7 / 2 }
  ]
});
svg4everybody();



// WEBPACK FOOTER //
// ../work/src/js/deferred.js